module.exports = __webpack_public_path__ + "img/section2_pic1@3x.58bf3396.png";